(function () {
  var DEFAULT_PAGE_SIZE = 6;
  var DEFAULT_PAGE_PARAM = 'page';

  function getPageParam(root) {
    return (root && root.getAttribute('data-page-param')) || DEFAULT_PAGE_PARAM;
  }

  function getPageSize(root) {
    var raw = Number(root && root.getAttribute('data-page-size'));
    if (!Number.isInteger(raw) || raw < 1) return DEFAULT_PAGE_SIZE;
    return raw;
  }

  function getUrlPage(root) {
    var params = new URLSearchParams(window.location.search);
    var rawPage = Number(params.get(getPageParam(root)));
    if (!Number.isInteger(rawPage) || rawPage < 1) return 1;
    return rawPage;
  }

  function syncUrl(root, page, replace) {
    var params = new URLSearchParams(window.location.search);
    var paramName = getPageParam(root);

    if (page > 1) {
      params.set(paramName, String(page));
    } else {
      params.delete(paramName);
    }

    var query = params.toString();
    var nextUrl = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
    var state = { videoLibraryPage: page };

    if (replace) {
      window.history.replaceState(state, '', nextUrl);
    } else {
      window.history.pushState(state, '', nextUrl);
    }
  }

  function buildEmbedUrl(videoId, autoplay) {
    var url = 'https://www.youtube.com/embed/' + encodeURIComponent(videoId) + '?enablejsapi=1&rel=0';
    if (autoplay) url += '&autoplay=1';
    return url;
  }

  function youtubeId(rawUrl) {
    var url = String(rawUrl == null ? '' : rawUrl).trim();
    if (!url) return '';
    var id = '';
    if (url.indexOf('youtu.be/') > -1) id = url.split('youtu.be/')[1];
    else if (url.indexOf('/embed/') > -1) id = url.split('/embed/')[1];
    else if (url.indexOf('watch?v=') > -1) id = url.split('watch?v=')[1];
    else if (url.indexOf('/v/') > -1) id = url.split('/v/')[1];
    if (!id) return '';
    return id.split('?')[0].split('&')[0].split('#')[0].trim();
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var PLAY_SVG =
    '<svg width="68" height="48" viewBox="0 0 68 48" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M66.52 7.74a8.4 8.4 0 0 0-5.91-5.94C55.83 1 34 1 34 1S12.17 1 7.39 1.8A8.4 8.4 0 0 0 1.48 7.74C.68 12.52.68 24 .68 24s0 11.48.8 16.26a8.4 8.4 0 0 0 5.91 5.94C12.17 47 34 47 34 47s21.83 0 26.61-.8a8.4 8.4 0 0 0 5.91-5.94c.8-4.78.8-16.26.8-16.26s0-11.48-.8-16.26Z" fill="#f03"/>' +
    '<path d="M27 34V14l17 10-17 10Z" fill="#fff"/>' +
    '</svg>';

  function cardHTML(video) {
    var id = escapeHtml(video.id);
    var title = escapeHtml(video.title);
    return (
      '<button type="button" class="vl-card" data-vl-card' +
      ' data-video-id="' + id + '" data-video-title="' + title + '" aria-label="' + title + '">' +
      '<span class="vl-card__media">' +
      '<img class="vl-card__image" src="https://img.youtube.com/vi/' + id + '/hqdefault.jpg"' +
      ' alt="" loading="lazy" width="480" height="360">' +
      '<span class="vl-card__play" aria-hidden="true">' + PLAY_SVG + '</span>' +
      '</span>' +
      (video.title ? '<span class="vl-card__title">' + title + '</span>' : '') +
      '</button>'
    );
  }

  function toggleEmpty(root, isEmpty) {
    var empty = root.querySelector('[data-vl-empty]');
    if (empty) empty.hidden = !isEmpty;
  }

  function ensureIframe(root) {
    var iframe = root.querySelector('[data-vl-iframe]');
    if (iframe) return iframe;
    var wrap = root.querySelector('[data-vl-player] .vl-player__wrap');
    if (!wrap) return null;
    iframe = document.createElement('iframe');
    iframe.className = 'vl-player__iframe';
    iframe.setAttribute('data-vl-iframe', '');
    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
    );
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'lazy');
    wrap.appendChild(iframe);
    return iframe;
  }

  var METAOBJECTS_QUERY =
    'query VideoLibrary($type: String!, $first: Int!, $after: String) {' +
    '  metaobjects(type: $type, first: $first, after: $after) {' +
    '    edges { node {' +
    '      handle displayName' +
    '      title: field(key: "title") { value }' +
    '      yt: field(key: "youtube_url") { value }' +
    '    } }' +
    '    pageInfo { hasNextPage endCursor }' +
    '  }' +
    '}';

  function sfRequest(root, query, variables) {
    if (window.StorefrontClient && typeof window.StorefrontClient.request === 'function') {
      return window.StorefrontClient.request(query, variables);
    }
    var shop = root.getAttribute('data-sf-shop');
    var version = root.getAttribute('data-sf-version') || '2024-10';
    var token = root.getAttribute('data-sf-token') || window.SF_API_TOKEN;
    if (!shop || !token) return Promise.resolve(null);
    return fetch('https://' + shop + '/api/' + version + '/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
      body: JSON.stringify({ query: query, variables: variables }),
    })
      .then(function (res) { return res.json(); })
      .catch(function () { return null; });
  }

  function fetchAllVideos(root, type) {
    var collected = [];

    function page(after, guard) {
      if (guard > 100) return Promise.resolve(collected);
      return sfRequest(root, METAOBJECTS_QUERY, { type: type, first: 100, after: after }).then(function (json) {
        var conn = json && json.data && json.data.metaobjects;
        if (!conn) return collected;
        (conn.edges || []).forEach(function (edge) {
          var node = edge && edge.node;
          if (!node) return;
          var rawUrl = node.yt && node.yt.value ? node.yt.value : '';
          var id = youtubeId(rawUrl);
          if (!id) return;
          var title = node.title && node.title.value ? node.title.value : node.displayName || node.handle || '';
          collected.push({ id: id, title: String(title).trim() });
        });
        var info = conn.pageInfo || {};
        if (info.hasNextPage && info.endCursor) return page(info.endCursor, guard + 1);
        return collected;
      });
    }

    return page(null, 0);
  }

  function hydrateFromStorefront(root) {
    var type = root.getAttribute('data-mo-type');
    if (!type) return;
    var token = root.getAttribute('data-sf-token') || window.SF_API_TOKEN;
    var hasClient = !!(window.StorefrontClient && window.StorefrontClient.request);
    if (!hasClient && !token) return;

    fetchAllVideos(root, type)
      .then(function (videos) {
        if (!videos) return;
        videos.reverse();

        if (!videos.length) {
          if (!root.querySelector('[data-vl-card]')) toggleEmpty(root, true);
          return;
        }

        var grid = root.querySelector('[data-vl-grid]');
        if (!grid) return;
        grid.innerHTML = videos.map(cardHTML).join('');
        toggleEmpty(root, false);

        applyPage(root, getUrlPage(root), { replaceUrl: true, resetPreview: true });
      })
      .catch(function () {
        /* Keep the server-rendered fallback. */
      });
  }

  function setActiveCard(cards, activeCard) {
    cards.forEach(function (card) {
      card.classList.toggle('is-active', card === activeCard);
    });
  }

  function loadVideo(root, videoId, videoTitle, autoplay, activeCard) {
    if (!videoId) return;

    var iframe = ensureIframe(root);
    if (!iframe) return;

    iframe.src = buildEmbedUrl(videoId, !!autoplay);
    iframe.title = videoTitle || 'YouTube video player';

    if (activeCard) {
      setActiveCard(root.querySelectorAll('[data-vl-card]'), activeCard);
    }
  }

  function scrollToPlayer(root) {
    var player = root.querySelector('[data-vl-player]');
    if (!player) return;
    player.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function renderPagination(nav, currentPage, totalPages, previousLabel, nextLabel) {
    if (!nav) return;

    if (totalPages <= 1) {
      nav.hidden = true;
      nav.innerHTML = '';
      return;
    }

    nav.hidden = false;
    nav.innerHTML = '';

    if (currentPage > 1) {
      var prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'vl-pagination__link';
      prev.textContent = previousLabel;
      prev.dataset.page = String(currentPage - 1);
      nav.appendChild(prev);
    }

    var status = document.createElement('span');
    status.className = 'vl-pagination__status';
    status.textContent = currentPage + ' / ' + totalPages;
    nav.appendChild(status);

    if (currentPage < totalPages) {
      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'vl-pagination__link';
      next.textContent = nextLabel;
      next.dataset.page = String(currentPage + 1);
      nav.appendChild(next);
    }
  }

  function applyPage(root, requestedPage, options) {
    options = options || {};
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-vl-card]'));
    var paginationNav = root.querySelector('[data-vl-pagination]');
    var pageSize = getPageSize(root);
    var totalPages = Math.max(1, Math.ceil(cards.length / pageSize));
    var currentPage = Math.max(1, Math.min(requestedPage || 1, totalPages));
    var start = (currentPage - 1) * pageSize;
    var end = start + pageSize;
    var firstVisibleCard = null;

    cards.forEach(function (card, index) {
      var visible = index >= start && index < end;
      card.hidden = !visible;
      if (visible && !firstVisibleCard) firstVisibleCard = card;
    });

    renderPagination(
      paginationNav,
      currentPage,
      totalPages,
      root.getAttribute('data-pagination-previous') || '\u00ab Previous',
      root.getAttribute('data-pagination-next') || 'Next \u00bb'
    );

    root.dataset.currentPage = String(currentPage);

    if (options.updateUrl !== false) {
      syncUrl(root, currentPage, !!options.replaceUrl);
    }

    if (options.resetPreview !== false && firstVisibleCard && !options.keepCurrentVideo) {
      loadVideo(
        root,
        firstVisibleCard.getAttribute('data-video-id'),
        firstVisibleCard.getAttribute('data-video-title') || '',
        false,
        firstVisibleCard
      );
    }

    return currentPage;
  }

  function initVideoLibrary(root) {
    if (!root || root.dataset.videoLibraryBound === 'true') return;
    root.dataset.videoLibraryBound = 'true';

    if (root.querySelectorAll('[data-vl-card]').length) {
      applyPage(root, getUrlPage(root), { replaceUrl: true, resetPreview: true });
    }

    root.addEventListener('click', function (event) {
      var target = event.target;

      if (!target || !target.closest) return;

      var card = target.closest('[data-vl-card]');
      if (card && root.contains(card) && !card.hidden) {
        event.preventDefault();
        loadVideo(
          root,
          card.getAttribute('data-video-id'),
          card.getAttribute('data-video-title') || '',
          true,
          card
        );
        scrollToPlayer(root);
        return;
      }

      var pageButton = target.closest('.vl-pagination__link[data-page]');
      if (pageButton && root.contains(pageButton)) {
        event.preventDefault();
        var page = Number(pageButton.dataset.page);
        if (!Number.isInteger(page) || page < 1) return;
        applyPage(root, page, { replaceUrl: false, resetPreview: true });
      }
    });

    window.addEventListener('popstate', function () {
      if (!document.body.contains(root)) return;
      applyPage(root, getUrlPage(root), { updateUrl: false, resetPreview: true });
    });

    hydrateFromStorefront(root);
  }

  function initAll() {
    document.querySelectorAll('[data-video-library]').forEach(initVideoLibrary);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target) return;

    var root =
      target.matches && target.matches('[data-video-library]')
        ? target
        : target.querySelector && target.querySelector('[data-video-library]');

    if (root) {
      delete root.dataset.videoLibraryBound;
      initVideoLibrary(root);
    }
  });
})();
